import React from "react";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

import { usePaginationTableContext } from "../PaginatedTable/context";

import { TABLE_PAGINATION_ROWS_PER_PAGE_OPTIONS } from "../../constants/styles";

export const TableFooterPagination = () => {
  const {
    page,
    colSpan,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePaginationTableContext();

  const getLabelDisplayedRows = ({ from, to }: Record<string, any>) =>
    `${from}-${to}`;

  return (
    <TableRow>
      <TablePagination
        count={-1}
        page={page}
        colSpan={colSpan + 2}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        labelRowsPerPage="Rows per page:"
        labelDisplayedRows={getLabelDisplayedRows}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={TABLE_PAGINATION_ROWS_PER_PAGE_OPTIONS}
      />
    </TableRow>
  );
};
